import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { ContentState } from './types';

export const initialState: ContentState = {
  trustItems: [],
};

export const { actions, reducer } = createSlice({
  name: 'content',
  initialState,
  reducers: {
    setContent: (state, { payload }: PayloadAction<ContentState>) => {
      if (payload.offerLabel) {
        state.offerLabel = payload.offerLabel;
      }

      if (payload.membershipBanner) {
        state.membershipBanner = payload.membershipBanner;
      }

      if (payload.deliveryFAQs) {
        state.deliveryFAQs = payload.deliveryFAQs;
      }

      if (payload.trustBanner) {
        state.trustBanner = payload.trustBanner;
      }

      state.trustItems = payload.trustItems;
    },
  },
});
